import { useNavigate } from 'react-router-dom';
import { useCallback, useRef } from 'react';

import useToaster from 'hooks/useToaster';
import { IPlayerNotification, PlayerNotificationType } from 'types/notifications';
import useNotifications from 'store/notifications';
import useSelectedLanguage from 'store/language';

export const useHandleNotification = (): ((params: IPlayerNotification) => void) => {
  const notify = useToaster();
  const navigate = useNavigate();
  const [{ selectedLanguage }] = useSelectedLanguage();
  const [, notificationActions] = useNotifications();

  const selectedLanguageRef = useRef(selectedLanguage);
  selectedLanguageRef.current = selectedLanguage;

  const handleNotification = useCallback(
    (notification: IPlayerNotification): void => {
      notificationActions.addNotification(notification);

      const currentLanguageTemplate =
        notification.template.translations.find(
          (translation) => translation.languageId === selectedLanguageRef.current.langId
        ) || notification.template.translations[0];

      const successMessageTypes = [
        PlayerNotificationType.ACCOUNT_VERIFIED,
        PlayerNotificationType.AVAILABLE_BONUS,
        PlayerNotificationType.WITHDRAW_APPROVED,
        PlayerNotificationType.DEPOSIT_SETTLED,
      ];

      notify({
        type: successMessageTypes.includes(notification.template.type) ? 'success' : 'error',
        message: currentLanguageTemplate.description,
        title: currentLanguageTemplate.title,
        onClick: (): void => {
          switch (notification.template.type) {
            case PlayerNotificationType.ACCOUNT_VERIFIED: {
              break;
            }
            case PlayerNotificationType.AVAILABLE_BONUS: {
              navigate('/bonuses');
              break;
            }
            case PlayerNotificationType.AVAILABLE_BONUS_EXPIRED: {
              navigate('/bonus-history');
              break;
            }
            case PlayerNotificationType.WITHDRAW_APPROVED: {
              navigate('/wallet-history');
              break;
            }
            case PlayerNotificationType.DEPOSIT_SETTLED: {
              navigate('/wallet-history');
              break;
            }
            case PlayerNotificationType.WITHDRAW_REJECTED: {
              navigate('/wallet-history');
              break;
            }
            default:
              break;
          }
          notificationActions.updateNotificationById(notification.id);
        },
      });
    },
    [navigate, notify, notificationActions]
  );

  return handleNotification;
};
